import { useQuery } from "@tanstack/react-query";
import { useAccessToken } from "@/hooks";
import { QueryKeys } from "@/lib/types";
import { createAuthenticatedApi } from "@/lib/utils";
import { WaiversPoliciesApi } from "@/openapi/generated";

interface UsePoliciesGetProps {
  page?: number;
  pageSize?: number;
  lastSelectedId?: number | null;
  active?: boolean | null;
  enabled?: boolean;
}

export const usePoliciesGet = (props?: UsePoliciesGetProps) => {
  const accessToken = useAccessToken();
  const {
    page = 1,
    pageSize = 1000,
    lastSelectedId,
    active,
    enabled = true,
  } = props || {};

  const { data, isError, isLoading, isSuccess, isPending } = useQuery({
    queryKey: [
      QueryKeys.Waivers,
      "admin",
      page,
      pageSize,
      lastSelectedId,
      active,
    ],
    queryFn: () => {
      if (!accessToken) {
        throw new Error("Authentication token is required");
      }
      const service = createAuthenticatedApi(WaiversPoliciesApi, accessToken);
      return service.apiPoliciesScrollGet({
        page,
        pageSize,
        lastSelectedId: lastSelectedId ?? undefined,
        active: active ?? undefined,
      });
    },
    enabled: !!accessToken && enabled,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
  });

  return {
    data,
    isError,
    isLoading,
    isSuccess,
    isPending,
  };
};
